export default __webpack_public_path__ + "favicon-152-67e3934b591c849cf7757d245010a677.bundle.png";